import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=65f88ae5&scoped=true"
import script from "./TabGeneral.vue?vue&type=script&lang=js"
export * from "./TabGeneral.vue?vue&type=script&lang=js"
import style0 from "./TabGeneral.vue?vue&type=style&index=0&id=65f88ae5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f88ae5",
  null
  
)

export default component.exports